import { appRoutes } from "Public/consts/appRoutes";

export const publicRoutes = [
  appRoutes.login,
  appRoutes.register,
  appRoutes.resetPassword,
  appRoutes.resetPasswordRequest,
  "verification-sent",
  "verification-retry",
  "email-verification",
  "new-email-verify",
  appRoutes.confirmTwoFactorEnable,
  appRoutes.confirmTwoFactorDisable,
  appRoutes.usernameChangeVerify,
  appRoutes.recoverUsername,
  appRoutes.recoverUsernameReveal,
].map((endpoint) => endpoint.replace("/", ""));
